import React, {useState} from 'react';
import Disclaimer from '../components/Disclaimer';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const DisclaimerPage = () => {
  const[isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
    };

  return (
    <>
    <ScrollToTop />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <Navbar toggle={toggle} />
    <Disclaimer />
    <Footer />
    </>
  )
}

export default DisclaimerPage;
